export default "__VITE_ASSET__lm_w7i9Z__"